import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  let data = isSuccessResponse(response)
  return data
}

const getCardsListInsertRequest = (mid: string, cardDetails: any[], isUpdateRequired: boolean) => {
  const cardList = cardDetails
    .filter(
      (card) => card.isDomesticAllowed === true || card.isInternationalAllowed === true || card.isPremium === true,
    )
    .map((card) => {
      return {
        cardType: card?.type,
        scheme: card?.scheme,
        isDomesticAllowed: card?.isDomesticAllowed ? 'Y' : 'N',
        isInternationalAllowed: card?.isInternationalAllowed ? 'Y' : 'N',
        isPremium: card?.isPremium ? 'Y' : 'N',
      }
    })
  return {
    mid: mid,
    cardDetails: cardList,
    updateRequired: isUpdateRequired ? 'Y' : 'N',
  }
}

const insertCards = (mid: string, cardDetails: any[], tokens: any, isUpdateRequired: boolean) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.cardsInsert),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: getCardsListInsertRequest(mid, cardDetails, isUpdateRequired),
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp))
    .catch((error) => {
      throw error
    })
}

export { insertCards }
